import { render } from "./Auth.vue?vue&type=template&id=16698dec&scoped=true"
const script = {}

import "./Auth.vue?vue&type=style&index=0&id=16698dec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16698dec"]])

export default __exports__